import { Config } from '@measured/puck';

import { createIndicatorsConfig } from '../blocks/molecules/indicators/create-indicators-config';

import { RootProps, createRootRenderer } from './render-root';

export const createRootConfig = (
  allRespondentTypes: Set<string>
): NonNullable<Config<RootProps, RootProps>['root']> => {
  const { defaultValue: defaultIndicators, fieldConfig: indicatorConfig } = createIndicatorsConfig(allRespondentTypes);
  return {
    defaultProps: {
      title: 'Questionnaire Title',
      indicators: defaultIndicators,
    },
    fields: {
      indicators: indicatorConfig,
      title: {
        type: 'text',
      },
    },
    render: createRootRenderer(),
  };
};
